export const unwrapApiResponse = (response) => {
  const body = response.data;

  if (!body?.success) {
    const error = new Error(body?.message || 'Request failed');
    error.errors = body?.errors || [];
    error.status = response.status;
    throw error;
  }

  return body.data;
};
